import { useEffect, useState } from 'react';
import { compose } from '@/utils/story-composer';
import { getUserCountryBasedOnGeo } from '@/utils/cookie-util';
import InputService from '@/utils/input-service';
import { getCountryBasedPriceLabel } from '@/utils/pricing';

function CountryBasedPriceLabel({ type = 'teacher', annual = null, amountIndentifier = null }) {
	const [country, setCountry] = useState(null);
	const [priceLabel, setPriceLabel] = useState('');
	const [amount, setAmount] = useState(1);

	useEffect(() => {
		const country = getUserCountryBasedOnGeo();
		const inputService = InputService.getInstance();
		const onInputChanged = () => {
			setAmount(parseInt(inputService.getInputValue(amountIndentifier), 10) || 1);
		};

		if (amountIndentifier) {
			try {
				setAmount(inputService.getInputValue(amountIndentifier) || 1);
				inputService.registerListener(amountIndentifier, onInputChanged);
			} catch (err) {
				console.error(err);
			}
		}

		if (country) {
			setCountry(country);
		}

		return () => {
			if (amountIndentifier) {
				inputService.unregisterListener(amountIndentifier, onInputChanged);
			}
		};
	}, []);

	useEffect(() => {
		const country = getUserCountryBasedOnGeo();
		const priceLabel = getCountryBasedPriceLabel(country, amount, type, annual === 'true');

		setPriceLabel(priceLabel);
	}, [type, country, annual, amount]);

	return `${priceLabel}`;
}

export default CountryBasedPriceLabel;
compose('country-based-price-label', CountryBasedPriceLabel);
